import { getCookieValue } from '../get-cookie-value';
/**
 * This will check if the current session is active and if the current user is logged in
 */
export const checkLoggedIn = (mockIsLoggedIn = false) => {
    const loginExpires = getCookieValue('login-expires');
    const isLoggedIn = !!loginExpires && parseInt(loginExpires, 10) > new Date().getTime();
    return PRODUCTION ? isLoggedIn : mockIsLoggedIn || isLoggedIn;
};
